import { create } from 'zustand';

type RequestState = {
  isLoading: boolean;
  error: string | null;
  startedAt?: string;
  finishedAt?: string;
};

interface ApiStatusStore {
  requests: Record<string, RequestState>;
  startRequest: (key: string) => void;
  finishRequest: (key: string, error?: string | null) => void;
}

export const useApiStatusStore = create<ApiStatusStore>((set) => ({
  requests: {},
  startRequest: (key: string) =>
    set((state) => ({
      requests: {
        ...state.requests,
        [key]: {
          ...state.requests[key],
          isLoading: true,
          error: null,
          startedAt: new Date().toISOString(),
          finishedAt: undefined
        }
      }
    })),
  finishRequest: (key: string, error: string | null = null) =>
    set((state) => ({
      requests: {
        ...state.requests,
        [key]: {
          ...state.requests[key],
          isLoading: false,
          error,
          finishedAt: new Date().toISOString()
        }
      }
    }))
}));

export const startApiRequest = (key: string): void => {
  useApiStatusStore.getState().startRequest(key);
};

export const finishApiRequest = (key: string, error?: string | null): void => {
  useApiStatusStore.getState().finishRequest(key, error ?? null);
};
